import AxiosApi from "@/config/axios";

const IncomeTaxService = {};

IncomeTaxService.get = (page = 1) => {
    return AxiosApi({
        url: `/contract-income-tax?page=${page}`,
        method: 'get',
    })
}

IncomeTaxService.getURL = (id) => {
    return AxiosApi({
        url: `/contract-income-tax/${id}/irpf`,
        method: 'get',
    })
}


export default IncomeTaxService;